export default __webpack_public_path__ + "assets/data-processing-addendum-cover-note.1f936e06439bd0bf3a19c172fedb25b8.pdf";